
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';
import USCoverageExplorer from 'src/components/docs/USCoverageExplorer'
export const metadata = {
  toc: true,
  layout: 'guide',
  description: "Search for product coverage by institution"
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Header title='US and Canada Bank Coverage Explorer' subtitle={metadata.description} mdxType="Header" />
    <p>{`Plaid supports over 10,000 institutions across the United States and Canada. `}</p>
    <p>{`Our coverage explorer below can help you see which Plaid products are supported by different financial institutions. Note that not all products are available in all countries. See `}<a parentName="p" {...{
        "href": "https://support.plaid.com/hc/en-us/articles/27895826947735-What-Plaid-products-are-supported-in-each-country-and-region"
      }}>{`this article`}</a>{` for a complete list of what products are supported in each country.`}</p>
    <p>{`This table is not updated in real time; for the most up to date data, use `}<inlineCode parentName="p">{`/institutions/get`}</inlineCode>{` or the `}<a parentName="p" {...{
        "href": "https://dashboard.plaid.com/activity/status/institution"
      }}>{`Institutions page`}</a>{` in the Dashboard. If you're interested in European bank coverage, see our `}<a parentName="p" {...{
        "href": "/docs/institutions/europe"
      }}>{`European Bank Coverage Explorer`}</a>{`. `}</p>
    <USCoverageExplorer mdxType="USCoverageExplorer" />
    <p><a parentName="p" {...{
        "href": "https://plaid.com/documents/us_institution_coverage.csv"
      }}>{`Download this coverage as CSV`}</a>{`.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
